import { render, staticRenderFns } from "./OfferList.vue?vue&type=template&id=5c61a1fc&"
import script from "./OfferList.vue?vue&type=script&lang=js&"
export * from "./OfferList.vue?vue&type=script&lang=js&"
import style0 from "./OfferList.vue?vue&type=style&index=0&id=5c61a1fc&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports